var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUttoLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.967846
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.999997 29.488655v-8.553569c0-9.219033-5.96937-17.0338741-14.249644-19.8254949v28.3790639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 71.179811v7.882102c0 9.015906 5.714814 16.68174 13.709578 19.626404v-27.508506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.932617 68.973357-34.860815-39.484702h18.043077v-29.488655h-31.176646c-11.564418 0-20.938233 9.3756985-20.938233 20.935086v45.333157l30.521974-34.573134 34.860814 39.484702h-18.040362v28.820189h31.72251c11.563961 0 20.935061-9.379631 20.935061-20.938087v-45.276037z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUttoLogo);
export default __webpack_public_path__ + "static/media/uttoLogo.5c3eaa6ccd8e7510ab38171dc118e3d1.svg";
export { ForwardRef as ReactComponent };